import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const MessageBannerDefaultProps = {
  ...ChildrenDefaultProps,
  ...ClassNameDefaultProps,
  type: 'info',
};

export const MessageBannerPropTypes = {
  ...ChildrenPropTypes,
  ...ClassNamePropTypes,
  type: PropTypes.oneOf(['info', 'danger', 'warning', 'success']),
};
